import ScrubbingRangeSlider from "./controlwrappers/ScrubbingRangeSlider";
import SelectControl from "./controlwrappers/SelectControl";
import RadioControl from "./controlwrappers/RadioControl";
import GuiHandler from "./GuiHandler";
import IndicatorHandler from "./IndicatorHandler";
import {
  IndicatorCategory,
  IndicatorOverviewObject,
  ParameterMeta,
} from "../../interfaces/resource.interfaces";

export default class IndicatorParameterHandler {
  #guiHandler: GuiHandler;
  #indicatorHandler: IndicatorHandler;

  constructor(guiHandler: GuiHandler, indicatorHandler: IndicatorHandler) {
    this.#guiHandler = guiHandler;
    this.#indicatorHandler = indicatorHandler;
  }

  addIndicatorParameterCategory(wrapper: any, category: IndicatorCategory) {
    const select = $(`#indicators${category} select`);

    const w = select?.width();
    const l = select?.offset()?.left;
    $(wrapper).append(
      `<div id="indicatorParameters${category}" style="width:${w}px;left:${l}px;display:none"><img class="indicatorInfo" src="img/info.png"></div>`
    );
    $(`#indicatorParameters${category} > img.indicatorInfo`)
      .first()
      .on("click", (evt) => {
        $(evt.currentTarget)
          .siblings(".parameters:visible")
          .children(".indicatorDocumentation")
          .fadeToggle();
      });
  }

  toggleParameterCategory(
    indicatorMeta: IndicatorOverviewObject,
    show: boolean
  ) {
    const nSpecificParams = indicatorMeta.parameters.filter(
      (p) => p.control.specific
    ).length;
    if (nSpecificParams > 0 && show) {
      $(`#indicatorParameters${indicatorMeta.category}`).slideDown();
    } else {
      $(`#indicatorParameters${indicatorMeta.category}`).fadeOut();
    }
  }

  setParameters(indicatorMeta: IndicatorOverviewObject) {
    const that = this;
    $(`#indicatorParameters${indicatorMeta.category} .parameters`).hide();
    var div = $(
      `#indicatorParameters${indicatorMeta.category} .${indicatorMeta.name}`
    );
    if (div.length === 0) {
      $(`#indicatorParameters${indicatorMeta.category}`).append(
        `<div class="parameters ${indicatorMeta.name}"><span class="indicatorParameterHeading">Einstellung des Indikators<br> "${indicatorMeta.displayname}":</span><div class="indicatorDocumentation">${indicatorMeta.documentation}</div></div></div>`
      );
      div = $(
        `#indicatorParameters${indicatorMeta.category} .${indicatorMeta.name}`
      );
      const finishedInteractionCallback = function () {
        //tiny cyclic dependency, to avoid trouble with 'that':
        that.#indicatorHandler.processIndicators([indicatorMeta]);
      };
      indicatorMeta.parameters.forEach((parameterMeta) => {
        if (parameterMeta.control.specific)
          that.#createParameterUI(
            div,
            parameterMeta,
            finishedInteractionCallback
          );
      });
    } else {
      //possible value reset
    }
    div.fadeIn();
  }

  getParameterValues(indicatorMeta: IndicatorOverviewObject) {
    var out: any = {};
    var that = this;
    indicatorMeta.parameters.forEach((parameter) => {
      if (parameter.control.specific) {
        const ctrl = $(`.parameters.${indicatorMeta.name}`).find(
          `.control.${parameter.name}`
        );
        out[parameter.name] = that.#getValueFromControl(ctrl);
        if (!out[parameter.name]) out[parameter.name] = parameter.defaultvalue;
      } else {
        if (parameter.name === "p_year") {
          out.p_year = $("#year-from").text(); //to-do: get from UI
        } else if (parameter.name === "p_municipality") {
          out.p_municipality = that.#guiHandler.getSelectedLocationID();
        } else if (parameter.name === "p_canton") {
          out.p_canton = that.#guiHandler.getSelectedLocationID();
        } else if (parameter.name === "p_aggregation") {
          out.p_aggregation = that.#guiHandler.getAggregation();
        }
      }
    });
    return out;
  }

  hideDeprecatedParameters(focusedCategory: IndicatorCategory) {
    $("#indicatorCategories > div").each((_, elem) => {
      const categoryName = $(elem).attr("id")?.replace("indicators", "");
      if (focusedCategory !== categoryName) {
        //find category with empty indicator selections:
        if ($(elem).children("option:selected").length < 1) {
          //hide the deprecated parameter panel
          $(`#indicatorParameters${categoryName}`).hide();
        }
      }
    });
  }

  #createParameterUI(
    wrapper: JQuery,
    parameterMeta: ParameterMeta,
    finishedInteractionCallback: Function
  ) {
    const lookup: any = {
      rangeslider: function (
        ctrlWrapper: JQuery,
        paraMeta: ParameterMeta,
        cb: Function
      ) {
        new ScrubbingRangeSlider(ctrlWrapper, paraMeta, cb);
      },
      multiselect: function (
        ctrlWrapper: JQuery,
        paraMeta: ParameterMeta,
        cb: Function
      ) {
        new SelectControl(ctrlWrapper, paraMeta, cb);
      },
      radio: function (
        ctrlWrapper: JQuery,
        paraMeta: ParameterMeta,
        cb: Function
      ) {
        new RadioControl(ctrlWrapper, paraMeta, cb);
      },
    };
    if (lookup.hasOwnProperty(parameterMeta.control.controltype)) {
      const controlWrapper = $('<div class="controlWrapper"></div>');
      controlWrapper.appendTo(wrapper);
      lookup[parameterMeta.control.controltype](
        controlWrapper,
        parameterMeta,
        finishedInteractionCallback
      );
    }
  }

  #getValueFromControl(ctrl: JQuery) {
    var ctrlWrapper = ctrl.data("public");
    if (ctrlWrapper) {
      return ctrlWrapper.getValue();
    }
    return null;
  }
}
